var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMutualIcCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "opqo5758",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.75 8.957V4.488h10.565v4.505c0 1.842-1.16 2.975-3.015 2.975H3.76c-1.839 0-3.01-1.156-3.01-3.011zm2.91-1.444a.482.482 0 0 1-.498-.469c0-.27.209-.493.476-.505a.48.48 0 0 1 .481.47.482.482 0 0 1-.458.504zm2.384 0a.482.482 0 0 1-.499-.469c0-.27.21-.493.476-.505a.48.48 0 0 1 .481.47.482.482 0 0 1-.458.504zm2.366 2.16a.497.497 0 0 1-.481-.499.488.488 0 0 1 .475-.498h.006c.273 0 .493.223.493.498 0 .276-.22.5-.493.5zm-2.865-.499c.012.27.232.482.5.47a.482.482 0 0 0 .457-.505.48.48 0 0 0-.481-.47.502.502 0 0 0-.476.505zm-2.389 0c.012.27.232.482.499.47a.482.482 0 0 0 .458-.505.48.48 0 0 0-.481-.47.502.502 0 0 0-.476.505zm4.778-2.136c0-.27.21-.487.476-.493.26 0 .47.21.481.47a.478.478 0 1 1-.957.03v-.007z",
    fill: "#58A7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "opqo5759",
    d: "M.752 4.488C.76 4.143.79 3.46.843 3.24c.279-1.238 1.224-2.025 2.575-2.137h5.23c1.34.118 2.297.91 2.575 2.137.054.214.083.903.09 1.248H.753z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "opqo5760",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.31 2.47a.438.438 0 0 1-.446.453.438.438 0 0 1-.447-.452V.68c0-.259.192-.452.447-.452s.446.193.446.452v1.79zm4.338 0a.442.442 0 0 1-.447.453.438.438 0 0 1-.446-.452V.68c0-.259.191-.452.446-.452.25 0 .447.193.447.452v1.79z",
    fill: "#58A7FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.752,
    y1: 1.103,
    x2: 0.752,
    y2: 4.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutualIcCalender);
export default __webpack_public_path__ + "static/media/Mutual___ic_calender.f7cab5f4.svg";
export { ForwardRef as ReactComponent };